var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 85.3333H18.2667L70.4 33.2L62.8 25.6L10.6667 77.7333V85.3333ZM0 96V73.3333L70.4 3.06667C71.4667 2.08889 72.6444 1.33333 73.9333 0.8C75.2222 0.266667 76.5778 0 78 0C79.4222 0 80.8 0.266667 82.1333 0.8C83.4667 1.33333 84.6222 2.13333 85.6 3.2L92.9333 10.6667C94 11.6444 94.7778 12.8 95.2667 14.1333C95.7556 15.4667 96 16.8 96 18.1333C96 19.5556 95.7556 20.9111 95.2667 22.2C94.7778 23.4889 94 24.6667 92.9333 25.7333L22.6667 96H0ZM66.5333 29.4667L62.8 25.6L70.4 33.2L66.5333 29.4667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.0aeba3d3d8375e296bcf1dcdbba9ebaa.svg";
export { ForwardRef as ReactComponent };